<template>
    <div class="aba-formulario">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="export-icon" @click="downloadArchive()">
            <b-icon
                icon="file"
                size="is-medium"
                class="is-medium is-clickable"
                v-tippy
                :title="$t('msg-tooltip-csv')"
            />
        </div>

        <div class="filters-bar mb-3">
            <div class="filters-bar-form form-columns-fit">
                <div class="columns">
                    <div class="column is-12">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="informacao-campo-busca-pesquisa-de-mercado"
                        />
                    </div>
                </div>
            </div>
            <div class="filters-bar-actions">
                <div class="filter-options">
                    <b-button
                        class="mr-2"
                        type="is-primary"
                        icon-right="pencil"
                        @click="showParametrizacao = !showParametrizacao"
                        v-tippy
                        :title="$t('selecao-campos')"
                    />
                </div>
            </div>
        </div>

        <div class="registry-wrapper">
            <div class="table-scroll-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    class="data-table"
                    :data="pesquisasMercadoList"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(field, index) in fields"
                        :key="index"
                        :field="field.key"
                        :width="field.width"
                        :label="field.key != 'excluir' ? $t(field.label) : ''"
                        :sortable="field.sortable"
                        :header-class="'has-text-centered'"
                        :cell-class="`has-text-centered ${field.cellClass}`"
                    >
                        <template v-slot="props">
                            <div v-if="field.key == 'qtdeMedia'">
                                <span
                                    v-if="props.row[field.key] > 0"
                                    @click="openModalFotos(props.row.id)"
                                    class="clickable"
                                >
                                    <b-icon
                                        class="has-badge-primary mt-1"
                                        :title="
                                            $t('msg-tooltip-pesquisa-n-fotos', {
                                                n: props.row[field.key],
                                            })
                                        "
                                        type="is-primary"
                                        icon="camera"
                                        :data-badge="props.row[field.key]"
                                        v-tippy
                                    />
                                </span>
                                <span v-else>
                                    <b-icon class="has-badge-primary mt-1" icon="camera" />
                                </span>
                            </div>
                            <div v-else>
                                {{ props.row[field.key] ? props.row[field.key] : '---' }}
                            </div>
                        </template>
                    </b-table-column>
                </b-table>
            </div>

            <PaginationViewer
                v-if="!isEmpty"
                class="mb-0 pagination-footer"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />

            <parametrizacao-campos
                codigounicotela="ven-atendimento-pesquisa-mercado"
                :showParametrizacao="showParametrizacao"
                @fecharModal="showParametrizacao = false"
                @table_fields="fields = $event"
            />
        </div>

        <b-modal
            class="modal-default"
            :active.sync="isShowModalFotos"
            style="z-index: 1000"
            @close="(carousels = []), (isShowModalFotos = false)"
        >
            <div class="modal-card-body">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <template>
                            <b-carousel :pause-info="false" :animated="'fade'" :progress="true">
                                <b-carousel-item v-for="(imagem, i) in imagensPesquisa" :key="i">
                                    <section class="hero is-medium">
                                        <div
                                            class="hero-body-img has-text-centered"
                                            :style="{
                                                backgroundImage: 'url(' + imagem.urlDocumento + ')',
                                                backgroundSize: 'contain',
                                                backgroundPosition: 'center center',
                                                backgroundRepeat: 'no-repeat',
                                                height: '200px',
                                                cursor: 'zoom-in',
                                            }"
                                            @click="() => toggleZoom(imagem.urlDocumento)"
                                        ></div>
                                        <div v-if="imagem.observacao" class="observacao-wrapper">
                                            <div class="observacao-titulo">Observação:</div>
                                            <div class="observacao-texto">
                                                {{ imagem.observacao }}
                                            </div>
                                        </div>
                                    </section>
                                </b-carousel-item>
                            </b-carousel>
                        </template>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import ExportacaoService from '@/services/ExportacaoService';

export default {
    components: {
        ContainerLoader,
    },
    props: {
        situacaoAtendimento: {
            type: Number,
            default: 0,
        },
        uuidFrom: {
            type: String,
            default: '',
        },
        idAtendimento: {
            type: Number,
            default: 0,
        },
        idMotivoAtendimento: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            pesquisasMercadoList: [],
            fields: [
                { key: 'codigo', label: 'codigo', sortable: true, visible: true },
                {
                    key: 'empresaNome',
                    label: 'empresaNome',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'empresaCodigo',
                    label: 'empresaCodigo',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'usuarioNome',
                    label: 'usuarioNome',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'clienteNome',
                    label: 'clienteNome',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'clienteCodigo',
                    label: 'clienteCodigo',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'clienteRSocial',
                    label: 'clienteRSocial',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'clienteCnpj',
                    label: 'clienteCnpj',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'produtoNome',
                    label: 'produtoNome',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'produtoCodigo',
                    label: 'produtoCodigo',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'produtoMarca',
                    label: 'produtoMarca',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'produtoGrupo',
                    label: 'produtoGrupo',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'produtoSubGrupo',
                    label: 'produtoSubGrupo',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'produtoLinha',
                    label: 'produtoLinha',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'produtoFamilia',
                    label: 'produtoFamilia',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'produtoCategoria',
                    label: 'produtoCategoria',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'qtdeGondola',
                    label: 'qtdeGondola',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'precoGondola',
                    label: 'precoGondola',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'qtdeGondolaConcorrente',
                    label: 'qtdeGondolaConcorrente',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'precoGondolaConcorrente',
                    label: 'precoGondolaConcorrente',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'observacao',
                    label: 'observacao',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'dataHora',
                    label: 'dataHora',
                    sortable: true,
                    visible: true,
                },
                {
                    key: 'qtdeMedia',
                    label: 'foto',
                    sortable: false,
                    visible: true,
                    width: 50,
                },
            ],
            isShowModalFotos: false,
            imagensPesquisa: [],
            showParametrizacao: false,
            filtro: {
                column: 'codigo',
                order: true,
                situacao: 0,
                currentPage: 1,
                perPage: null,
            },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: 10,
                totalRows: 0,
                currentPage: 1,
            },
            service: new ExportacaoService(this.$http, this.$router),
            exportacaoTipo: {},
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'datahorainc',
            order: 'asc',
            isSaving: false,
            delete: null,
        };
    },
    created() {
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        async carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;

            this.filtro.currentPage = currentPage - 1;
            this.filtro.perPage = this.pagination.perPage;
            this.filtro.queryFilter = this.queryFilter;

            const response = await this.$axios.post(
                '/crm/pesquisa-mercado/' + this.idAtendimento + '.json',
                this.filtro
            );

            if (response && response.data && response.data.content) {
                this.pagination.totalRows = response.data.totalElements;
                this.pesquisasMercadoList = response.data.content;
            }

            this.dataIsEmpty =
                !response ||
                !response.data ||
                !response.data.content ||
                this.pesquisasMercadoList.length <= 0;

            this.isLoading = false;
        },
        async openModalFotos(id) {
            const response = await this.$axios.get('/crm/pesquisa-mercado/fotos/' + id + '.json');

            if (response && response.data && response.data.content) {
                this.imagensPesquisa = response.data.content;
            }

            this.isShowModalFotos = true;
        },
        toggleZoom(imagem) {
            const h = this.$createElement;
            const vnode = h('p', { class: 'image' }, [h('img', { attrs: { src: imagem } })]);
            this.$buefy.modal.open({ content: [vnode] });
        },
        async downloadArchive() {
            const response = await this.$axios.post(
                '/crm/pesquisa-mercado/' + this.idAtendimento + '.csv',
                this.filtro,
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            const blob = new Blob([response.data]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'pesquisa-mercado.csv';
            link.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(blob);
            }, 100);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;

            this.filtro.column = this.column;
            this.filtro.order = this.order == 'asc';
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = value;
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-formulario {
    height: 100%;
    display: flex;
    flex-direction: column;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    .bar {
        position: absolute;
        top: 5px;
        bottom: 5px;
        left: 5px;
        right: 5px;
        border-radius: 100px;
        width: 5px;
        min-height: 25px;
        &.bar-em-preenchimento {
            background-color: #fd5858;
        }
        &.bar-nao-finalizado {
            background-color: #ffb93f;
        }
        &.bar-finalizado {
            background-color: #84bd42;
        }
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}

.export-icon {
    color: var(--primary-color);
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
}

.registry-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.table-scroll-wrapper {
    flex: 1;
    overflow-x: auto;
    overflow-y: auto;
}

.aba-formulario ::v-deep .table-wrapper {
    overflow-x: visible;
}

::v-deep .carousel-indicator {
    position: static !important;
    margin-top: 1rem;
    text-align: center;
}

::v-deep .observacao-wrapper {
    text-align: center;
    margin-top: 1rem;
    padding: 0 1rem;
    max-width: 90%;
    margin-left: auto;
    margin-right: auto;
}

::v-deep .observacao-titulo {
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 0.25rem;
}

::v-deep .observacao-texto {
    font-size: 0.9rem;
    word-break: break-word;
    white-space: normal;
    max-width: 100%;
}

.pagination-footer {
    padding-top: 1rem;
}

.filters-bar {
    display: flex;
    padding: 20px 0 10px 0;
    .filters-bar-form {
        flex-grow: 1;
    }
    .filters-bar-actions {
        padding: 16px 0 2px 10px;
        display: flex;
        align-items: stretch;
    }
    @media screen and (max-width: 850px) {
        flex-direction: column;
        .filters-bar-actions {
            align-self: center;
        }
    }
}

.list {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.icon-handle {
    svg {
        width: 20px;
        height: 20px;
    }
}

.link {
    flex: 1;
}

.container {
    display: flex;
    align-items: center;
}

.manage-content {
    padding: 20px;
}

.location-icon:hover {
    color: $primary-color-hover;
    cursor: pointer;
}

.location-icon {
    color: $primary-color;
    &.disabled {
        opacity: 0.3;
    }
}

.data-table {
    height: 100%;
}

@media screen and (max-width: 850px) {
    .filters-bar-actions {
        justify-content: center;
    }
}
</style>
